function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  fillRule: "nonzero",
  d: "M15.98 10.979c-4.452 2.497-8.067 5.886-10.851 10.174-9.368 14.424-5.323 33.453 9.101 42.82 14.425 9.368 33.454 5.323 42.821-9.101 9.367-14.425 5.323-33.453-9.102-42.82l-.844-.543c-.11-.069-.21-.13-.304-.187l-.456-.262a10.358 10.358 0 00-1.164-.555l-2.627 5.092c.29.114.58.25.878.41l.295.164c.291.168.592.358 1.1.688l.351.232c11.497 7.728 14.64 22.993 7.065 34.658-7.652 11.783-23.108 15.069-34.89 7.417C5.57 51.514 2.284 36.058 9.936 24.275a26.23 26.23 0 019.032-8.498l-2.524-5.054-.463.256z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#1D998C",
  strokeWidth: 5.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8 34.4L30.792 48 44.6 34.4"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M30.6 3.6v39.2"
})));

var SvgCircleDown = function SvgCircleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 70,
    viewBox: "0 0 63 70"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/circle-down.2a98d138.svg";
export { SvgCircleDown as ReactComponent };